export default __webpack_public_path__ + "static/media/ACS.219bb21c.png";